import React, { useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import Select from "react-select";
import Switch from "react-ios-switch";
import globalEnum from "../../../enums/globalEnum";
import { timeToDecimal } from "../../../layouts/DigitalTimePicker";
import { useResponsive } from "../../../hooks/useResponsive";
import tools from "../../../utils/tools";
import { AdapterMomentJalaali } from "@mui/x-date-pickers/AdapterMomentJalaali";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopTimePicker as TimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import Container from "@mui/material/Container";
const { orderStatus, orderStatusNames } = globalEnum;

interface OrderInfoSectionProps {
  form: any;
  updateFormField: (field: string, value: any) => void;
  updateNestedField: (parent: string, field: string, value: any) => void;
  urgentAllPrices: (isUrgent: boolean) => void;
}

const decimalToTime = (decimal: number): { hour: number; minute: number } => {
  const hour = Math.floor(decimal);
  const minuteDecimal = decimal - hour;
  const minute = Math.round(minuteDecimal * 60);
  return { hour, minute };
};

const OrderInfoSection: React.FC<OrderInfoSectionProps> = ({
  form,
  updateFormField,
  urgentAllPrices,
}) => {
  const { getSelectStyles } = useResponsive();

  const statusOptions = Object.entries(orderStatus).map(([key, value]) => ({
    value: key,
    label: orderStatusNames[key],
  }));

  const handleDateChange = (date: any) => {
    updateFormField("date", tools.persianNumToEn(date.format("YYYY/MM/DD")));
  };

  return (
    <div className="infoSection">
      <h1 className="dashBoardTitle">اطلاعات سفارش</h1>
      <div className="orderInfoBox">
        {form?.code && (
          <span className="factorHeader">
            <p>{form.code}</p>
          </span>
        )}

        <label className="sideBarTitle" htmlFor="orderStatus">
          وضعیت سفارش
        </label>
        <Select
          id="orderStatus"
          name="status"
          styles={getSelectStyles()}
          className="minWidth150"
          placeholder="انتخاب وضعیت"
          isSearchable={false}
          aria-label="وضعیت سفارش"
          value={{
            value: Object.keys(orderStatus).find((e) => e === form?.status),
            label:
              orderStatusNames[
                Object.keys(orderStatus).find((e) => e === form?.status) || ""
              ],
          }}
          options={statusOptions}
          onChange={(selected) => updateFormField("status", selected.value)}
        />

        <label className="sideBarTitle" htmlFor="orderDate">
          تاریخ
        </label>
        <DatePicker
          id="orderDate"
          inputClass="editProductInput"
          calendar={persian}
          locale={persian_fa}
          value={form?.date}
          onChange={handleDateChange}
          placeholder="انتخاب تاریخ"
          aria-label="تاریخ"
        />

        <div className="orderManageDateTime">
          <div className="orderManageTime">
            <label className="sideBarTitle" htmlFor="orderTime">
              از ساعت
            </label>
            <LocalizationProvider dateAdapter={AdapterMomentJalaali}>
              <Container className="orderManageTimeInput">
                <TimePicker
                  defaultValue={moment("08:00", "HH:mm")}
                  ampm={false}
                  className="orderManageTimeInput"
                  minTime={moment("08:00", "HH:mm")}
                  maxTime={moment("23:45", "HH:mm")}
                  timeSteps={{ minutes: 15 }}
                  value={moment(
                    `${decimalToTime(form.time).hour}:${decimalToTime(form.time).minute}`,
                    "HH:mm",
                  )}
                  onChange={(date) => {
                    updateFormField(
                      "time",
                      timeToDecimal(
                        Number(date.format("HH")),
                        Number(date.format("mm")),
                      ),
                    );
                  }}
                />
              </Container>
            </LocalizationProvider>
            {/*<DigitalTimePicker
              hour={fromHour}
              setHour={setFromHour}
              minute={fromMinute}
              setMinute={setFromMinute}
              minHour={8}
              maxHour={24}
              disabledHours={[]}
              onTimeChange={(hour, minute) => {
                fromTime.current = { hour, minute };
              }}
            />*/}
            {/*<input
              id="orderTime"
              className="editProductInput"
              type="text"
              value={form?.time || ""}
              onChange={(e) => updateFormField("time", e.target.value)}
              aria-label="ساعت"
            />*/}
          </div>
          <div className="orderManageTime">
            <label className="sideBarTitle" htmlFor="orderTime">
              تا ساعت
            </label>
            <LocalizationProvider dateAdapter={AdapterMomentJalaali}>
              <Container className="orderManageTimeInput">
                <TimePicker
                  defaultValue={moment("08:00", "HH:mm")}
                  ampm={false}
                  minTime={moment("08:00", "HH:mm")}
                  maxTime={moment("23:45", "HH:mm")}
                  timeSteps={{ minutes: 15 }}
                  value={moment(
                    `${decimalToTime(form.toTime).hour}:${decimalToTime(form.toTime).minute}`,
                    "HH:mm",
                  )}
                  onChange={(date) => {
                    updateFormField(
                      "toTime",
                      timeToDecimal(
                        Number(date.format("HH")),
                        Number(date.format("mm")),
                      ),
                    );
                  }}
                />
              </Container>
            </LocalizationProvider>
            {/*<DigitalTimePicker
              hour={toHour}
              setHour={setToHour}
              minute={toMinute}
              setMinute={setToMinute}
              disabledHours={[]}
              minHour={8}
              maxHour={24}
              onTimeChange={(hour, minute) => {
                toTime.current = { hour, minute };
              }}
            />*/}
            {/*<input
              id="orderTime"
              className="editProductInput"
              type="text"
              value={form?.toTime || ""}
              onChange={(e) => updateFormField("toTime", e.target.value)}
              aria-label="ساعت"
            />*/}
          </div>
        </div>
        <div className="inputRow">
          <Switch
            checked={form.isUrgent || false}
            onChange={(checked) => {
              updateFormField("isUrgent", checked);
              urgentAllPrices(checked);
            }}
            aria-label="سفارش فوری"
          />
          <label className="sideBarTitle">سفارش فوری</label>
        </div>

        {form?.description && (
          <>
            <label className="sideBarTitle" htmlFor="orderDescription">
              توضیحات مشتری
            </label>
            <textarea
              id="orderDescription"
              className="editProductInput"
              value={form.description}
              readOnly
              rows={4}
              aria-label="توضیحات مشتری"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default OrderInfoSection;
